export default __webpack_public_path__ + "static/media/component-review.a0d7019a.png";